import defaultReducer from './defaultReducer';
import { defaultGrid } from '../../helpers/datagrid';
import moment from 'moment';
import { defaultFromDate } from '../../config/dates';

export const kioskDefaultState = {
    filters: {
        fromDate: moment().subtract(14, 'days'),
        toDate: moment(),
        currentDate: true,
        includeEvents: false,
        periodId: 2,
        loading: false,
        page: 1
    },
    activeRow: null,
    transactions: {
        ...defaultGrid,
        pageCount: 1
    },
    summary: defaultGrid,
    positions: {
        ...defaultGrid,
        optionAllowExport: false,
    },
    details: defaultGrid
}

export default defaultReducer('KIOSK_VIEW', kioskDefaultState);

